import React from "react";
import AddressItem from "../Domain/AddressItem.js";
import serviceHelper from "../Helpers/serviceHelper.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import AddressSearchParams from "../Contents/Sales/AddressAdmin/AddressSearchParams";

class AddressService extends React.Component {
  static GetAddressList(leadId) {
    const authService = AuthService.getInstance();

    let url = "/api/Address";

    if (leadId != null && leadId !== -1) {
      url += `/${leadId}`;
    }

    const result = authService.CallBackendFunction(url);
    AddressService.leadList = result;
    AddressService.prevLeadId = leadId;
    return result;
  }

  static GetAddressByEntityAndEntityId(entityId, entity) {
    const url = `/api/Address/GetAddressByEntityAndEntityId/?entity=${entity}&entityId=${entityId}`;

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }

  static GetAddressListByEntityAndEntityId(entityId, entityTypeId) {
    const authService = AuthService.getInstance();

    const url = `/api/Address/GetAddressListByEntityAndEntityId/?entityId=${entityId}&entityTypeId=${entityTypeId}`;

    return authService.CallBackendFunction(url);
  }

  static GetAddressListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(searchItem, AddressSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/Address/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new AddressItem(item));
    }

    return [];
  }

  static EditAddress(address) {
    address = serviceHelper.ConvertAllPropertyToString(address);
    const addressJSON = JSON.stringify(address);

    return AuthService.getInstance().CallBackendFunctionPut("/api/Address/EditAddress", addressJSON);
  }

  static GetAddressById(id) {
    const url = `/api/Address/GetAddressById/${id}`;

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }
}

export default AddressService;
